import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalFaqComponent } from './legal-faq.component';
import { LegalFaqRoutingModule } from './legal-faq-routing.module';
import { TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    LegalFaqComponent
  ],
  imports: [
    CommonModule,
    LegalFaqRoutingModule,
    TranslatePipe
  ]
})
export class LegalFaqModule { }

